// extracted by mini-css-extract-plugin
export default {"loginContainer":"demo_loginContainer__U2ndv","switchLoginLink":"demo_switchLoginLink__1Ijmx","loginPageContainer":"demo_loginPageContainer__IKf7M"};